import React from 'react';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { date } from 'core/day-of-week';
import { useTranslation } from 'hooks/use-translation';
import { Label01 } from 'ozone/atoms';
import { orderedDays } from '../../asu-utils';
import { OnDaySelector } from '../styles';

const RadioGroup = styled(Radio.Group)`
  .ant-radio-group-item {
    margin-right: var(--spacing-03);
  }

  .ant-radio + span {
    padding-left: var(--spacing-02);
  }
`;

interface Props {
  onChange: (e: string) => void;
  weekDay: {
    value: string;
    label: string;
  };
}

export const WeekDaySelector = ({
  onChange,
  weekDay,
}: Props): React.ReactElement => {
  const options = orderedDays.map((x) => ({
    value: x.toUpperCase(),
    label: <Label01>{date(x).format('dd')}</Label01>,
  }));

  const onUpdate = (e) => {
    onChange(e.target.value);
  };

  const selectorLabel = useTranslation(
    'templates.status_updates.tab.config.freq.on_day',
  );

  return (
    <OnDaySelector label={selectorLabel}>
      <RadioGroup options={options} value={weekDay.value} onChange={onUpdate} />
    </OnDaySelector>
  );
};
